import React from 'react';
import {Card, CardBody, CardHeader, CardFooter, Box, Button, Heading, Image, Text} from 'grommet';
import {Clock, Link, MailOption, Map, Phone} from 'grommet-icons';

const ShopList = ({ shops }) => {
    return (
        <Box flex overflow="auto">
            {shops.map(shop => (
                <Card key={shop.id} margin="medium">
                    <CardHeader pad="medium" justify="between">
                        <Heading
                            color={"brand"}
                            size={"small"}
                        >
                            {shop.name}
                        </Heading>
                    </CardHeader>
                    <CardBody pad="small">
                        <Box
                            direction={"column"}
                            gap={"medium"}
                            responsive={true}
                            pad={"medium"}
                        >
                            <Image
                                fit="cover"
                                src={process.env.REACT_APP_BASE_API_URL+"assets/stores/"+shop.imagePath}
                                a11yTitle="bridge"
                            />
                            <Box
                                direction={"row"}
                                gap={"small"}
                            >
                                <Map
                                    color={"brand"}>
                                </Map>
                                <Text>{shop.address}</Text>
                            </Box>
                            <Box
                                direction={"row"}
                                gap={"small"}
                            >
                                <Phone
                                    color={"brand"}>
                                </Phone>
                                <Text>
                                    <a href={"tel:" + shop.phone}>{shop.phone}</a>
                                </Text>
                            </Box>
                            <Box
                                direction={"row"}
                                gap={"small"}
                            >
                                <MailOption
                                    color={"brand"}>
                                </MailOption>
                                <Text>
                                    <a href={"mailto:" + shop.email} target={"_blank"}> {shop.email} </a>
                                </Text>
                            </Box>
                        </Box>
                    </CardBody>
                    <CardFooter pad={{horizontal: "medium", vertical: "small"}} alignContent={"around"} align={"baseline"}
                                justify={"around"}>
                        <Button hoverIndicator href={shop.link} target={"_blank"} label={"Google Maps"}/>
                    </CardFooter>
                </Card>
            ))}
        </Box>
    );
};

export default ShopList;
